import { Pipe, PipeTransform } from '@angular/core';
import { DocumentTypeEnum } from '../passengers-details-indra/passenger-detail-personal-documents/enum/document-type.enum';

@Pipe({
  name: 'documentTypeDesc'
})
export class DocumentTypeDescPipe implements PipeTransform {

	transform(value: any, args?: any): any {
		return DocumentTypeEnum.description(value);
	}

}
